import { Route, Routes } from "react-router-dom";

// Pages
import Form from "./pages/Form";
import Landing from "./pages/Landing";
import LogoPage from "./pages/Logo";

// Components
import PDFDocument from "./pages/Form/PDF";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/simulador/:segmento" element={<Form />} />
      <Route path="/logo_grupo_guerra.png" element={<LogoPage />} />
      <Route path="/pdf/" element={<PDFDocument />} />
    </Routes>
  );
}

export default App;
